import {Component, OnInit} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {Observable} from 'rxjs';
import {Message} from 'primeng/api';
import {ShellMessageService} from '../../service/shell-message-service';

@Component({
  selector: 'cf-shell-messages',
  templateUrl: './shell-messages.component.html',
  styleUrls: ['./shell-messages.component.scss'],
  animations: [
    trigger('messageIn', [
      state('in', style({
        marginTop: '.5em',
        opacity: '1',
      })),
      transition(':enter', [
        style({marginTop: '3em', opacity: '.9'}),
        animate('200ms ease-out'),
      ]),
      transition(':leave', [
        animate('200ms ease-out', style({marginTop: '-3em', opacity: '.2'})),
      ]),
    ]),
  ],
})
export class ShellMessagesComponent implements OnInit {
  messages$: Observable<Message[]>;

  constructor(
    private shellMessagesService: ShellMessageService,
  ) {
  }

  ngOnInit(): void {
    this.messages$ = this.shellMessagesService.getMessages$();
  }

  onMessageClick(m: Message) {
    this.shellMessagesService.clearMessage(m);
  }
}
